const dateTranslations = {
    common: {
        long: '{{date, long}}',
        date: '{{date, date}}',
        dayMonth: '{{date, dayMonth}}',
        dayMonthYearShort: '{{date, dayMonthYearShort}}',
        monthYear: '{{date, monthYear}}',
        weekday: '{{date, weekday}}',
        weekdayShort: '{{date, weekdayShort}}',
        timeShort: '{{date, timeShort}}',
        custom: '{{date, customDateFormat}}',

        distanceToNow: '{{date, distanceToNow}}'
    }
} as const;

export default dateTranslations;
